import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  listHeader: {
    border: 0,
    boxShadow: 'none',
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  headerContainer: {
    marginTop: 0,
    height: 'fit-content',
    padding: '8px 0',
    gap: '16px',
    borderTop: `1px solid ${capitalDesignTokens.foundations.colors.gray400}`
  },
  header: {
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold
  },
  searchAndSortingContainer: {
    marginBottom: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '8px'
  },
  skeletonContainer: {
    gap: '8px'
  },
  folderSkeleton: {
    height: '32px'
  },
  list: {
    minHeight: '82px',
    overflowY: 'auto',
    border: `1px solid ${capitalDesignTokens.foundations.colors.gray200}`,
    borderRadius: '4px',
    backgroundColor: capitalDesignTokens.foundations.colors.white
  },
  noMatchingFolders: {
    display: 'flex',
    justifyContent: 'center'
  }
});
